module.exports = __webpack_public_path__ + "static/media/laptop.e343e604.png";